import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { Shell } from '@/shell/Shell'
import { SessionGate } from '@/shell/SessionGate'
import { FullPage, WithLender } from '@/shell/FullPage'
import { Playground } from '@/screens/lender/api/playground/Playground'
import { WorkflowEditor } from '@/screens/lender/flow/WorkflowEditor'
import { DashboardScreen } from '@/screens/DashboardScreen'
import { DocsScreen } from '@/screens/docs/DocsScreen'
import { LendersScreen } from '@/screens/lenders/LendersScreen'
import { AddLenderScreen } from '@/screens/lenders/AddLenderScreen'
import { LenderScreen } from '@/screens/lender/LenderScreen'
import { HubApiScreen } from '@/screens/other/HubApiScreen'
import { CatalogueScreen } from '@/screens/other/CatalogueScreen'
import { AlertsScreen } from '@/screens/other/AlertsScreen'
import { UsersScreen } from '@/screens/other/UsersScreen'
import { ProfileScreen } from '@/screens/other/ProfileScreen'
import { ActiveEndpointsScreen } from '@/screens/gateway/ActiveEndpointsScreen'
import { RunsScreen } from '@/screens/gateway/RunsScreen'
import { CodeStorageScreen } from '@/screens/gateway/CodeStorageScreen'
import { SettingsScreen } from '@/screens/gateway/SettingsScreen'
import { MisScreen } from '@/screens/mis/MisScreen'
import { useCurrentUser } from '@/shell/useCurrentUser'

/** The home page: the Dashboard, or the MIS for an MIS uploader (HM2: they see nothing else). */
function Home() {
  const { can } = useCurrentUser()
  return !can('lenders.view') && can('mis.upload') ? <Navigate to="/mis" replace /> : <DashboardScreen />
}

function WorkflowPage() {
  const { wfId = '' } = useParams()
  return <WithLender>{(lender) => <WorkflowEditor lender={lender} wfId={wfId} />}</WithLender>
}

// Addresses carry slugs, tab names, versions and file paths only, never personal data.
export default function App() {
  return (
    <SessionGate>
    <Routes>
      {/* the pages that take the whole window: the two work pages (owner, 2026-10-17) and the docs (C-1b) */}
      <Route element={<FullPage />}>
        <Route path="lenders/:slug/playground" element={<WithLender>{(lender) => <Playground lender={lender} />}</WithLender>} />
        <Route path="lenders/:slug/workflows/:wfId" element={<WorkflowPage />} />
        <Route path="docs/:page?" element={<DocsScreen />} />
      </Route>
      <Route element={<Shell />}>
        <Route index element={<Home />} />
        <Route path="lenders" element={<LendersScreen />} />
        <Route path="lenders/new" element={<AddLenderScreen />} />
        <Route path="lenders/:slug/:tab?/:sub?" element={<LenderScreen />} />
        <Route path="hub-api" element={<HubApiScreen />} />
        <Route path="catalogue" element={<CatalogueScreen />} />
        <Route path="alerts" element={<AlertsScreen />} />
        <Route path="users" element={<UsersScreen />} />
        <Route path="profile" element={<ProfileScreen />} />
        <Route path="endpoints" element={<ActiveEndpointsScreen />} />
        <Route path="runs" element={<RunsScreen />} />
        <Route path="storage" element={<CodeStorageScreen />} />
        <Route path="settings/:tab?" element={<SettingsScreen />} />
        <Route path="mis/files/:id" element={<MisScreen />} />
        <Route path="mis/:tab?" element={<MisScreen />} />
        <Route path="guide" element={<Navigate to="/docs" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
    </SessionGate>
  )
}
